import { useMemo } from 'react';
import { Optional } from 'utility-types';
import { FieldSectionType } from 'api/field-sections/types';
import { User } from 'api/models';
import { useAllFieldsQuery } from 'queries';

export const useContactType = (user: Optional<User>) => {
  const { data: allFields } = useAllFieldsQuery();

  const contactType = useMemo(
    () =>
      (allFields ?? [])?.find(
        (val) =>
          val.fieldName === 'contactType' &&
          val.objectType === FieldSectionType.Users,
      ),
    [allFields],
  );
  const userContactType = user.fields?.find(
    (field) => field.fieldId === contactType?.fieldId,
  );

  if (userContactType) {
    return userContactType;
  }

  return null;
};
